export const CATEGORY_TYPES = [
  { text: 'Topic', value: 'topic' },
  { text: 'Group', value: 'group' },
];

export const ILLUSTRATIONS = [{ text: 'Banana', value: 'banana' }];
